export default "__VITE_PUBLIC_ASSET__027b7b74__"